import ClientsHeroSection from '../components/Clients/ClientsHeroSection';
import TrustedBySection from '../components/Clients/TrustedBySection';
import CaseStudySection from '../components/Clients/CaseStudySection';
import WhyChooseUsSection from '../components/Clients/WhyChooseUsSection';
import QuoteSection from '../components/Clients/QuoteSection';
import OurServicesSection from '../components/Clients/OurServicesSection';
import Silk from '../components/SilkBackground';

function Clients() {
  return (
    <>
      {/* Silk background */}
      <div className="fixed inset-0 -z-10 pointer-events-none">
        <Silk
          speed={10}
          scale={1}
          color="#e3c8b3"
          noiseIntensity={1.5}
          rotation={0}
        />
      </div>


      <div className='bg-[#f2d6c0]/80 backdrop-blur-md'>
        {/* Clients Hero Section */}
        <ClientsHeroSection />

        {/* Trusted By Section */}
        <TrustedBySection />

        {/* Why Choose Us Section */}
        <WhyChooseUsSection />

        {/* Case Studies Section */}  
        <CaseStudySection />

        {/* Quote Section */}
        {/* <QuoteSection /> */}

        {/* Our Services Section */}
        <OurServicesSection />
      </div>
    </>
  );
}

export default Clients;
  